import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useCompanionAuth } from "@/context/CompanionAuthContext";
import { Loader2 } from "lucide-react";

const CompanionGuard = () => {
  const { user, ready } = useCompanionAuth();
  useEffect(() => {
    // Register the PWA service worker once a crew member is in the app
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/sw.js").catch(() => { /* non-fatal */ });
    }
  }, []);

  if (!ready) {
    return <div className="min-h-screen grid place-items-center bg-crest-surface">
      <Loader2 className="h-7 w-7 animate-spin text-crest-green" />
    </div>;
  }
  if (!user) return <Navigate to="/companion/login" replace />;
  return <Outlet />;
};

export default CompanionGuard;
